import axios from 'axios'

const loqateApi = axios.create({
  baseURL: process.env.NEXT_PUBLIC_LOQATE_URL,
  originURL: process.env.NEXT_PUBLIC_LOQATE_URL,
  headers: {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  },
})

// **** intercepts before making an API call:
loqateApi.interceptors.request.use(
  (config) => {
    const { ...configItems } = config

    configItems.params.Key = process.env.NEXT_PUBLIC_LOQATE_KEY
    configItems.url += '/json3ex.ws'

    return configItems
  },
  (error) => Promise.reject(error)
)

export default loqateApi
